import React from 'react';
import { formatMoneyParts } from '../../utils/currency';
import './styles.css';

/**
 * Exibe um valor monetário respeitando o modo de exibição da empresa.
 *
 * POR QUE UM COMPONENTE, E NÃO UMA STRING
 * `formatMoneyParts` devolve `{ primary, secondary }` separados de propósito.
 * Se a segunda moeda viesse colada numa string, não daria para deixá-la menor e
 * em cinza — e aí ela competiria visualmente com o preço que realmente vale para
 * cobrança. O cliente precisa bater o olho e saber qual número é o preço.
 *
 * ONDE USAR
 * Só nos pontos de DECISÃO e de PAGAMENTO: detalhe do item, carrinho, subtotal,
 * entrega, desconto e total. NÃO usar na listagem longa do cardápio nem em cada
 * adicional — ali o cliente está comparando itens entre si, e duas moedas em 40
 * cards só poluem a tela do celular.
 *
 * Quando a empresa não usa exibição dupla, renderiza exatamente como antes:
 * um único <span> com o valor. Zero diferença visual para o Brasil.
 */
function Money({ value, ctx, className = '', inline = false }) {
    const { primary, secondary } = formatMoneyParts(value, ctx);

    if (!secondary) {
        return <span className={className}>{primary}</span>;
    }

    return (
        <span className={`money-dual ${inline ? 'money-dual--inline' : ''} ${className}`}>
            <span className="money-dual__primary">{primary}</span>
            {/* O til já vem de formatMoneyParts marcando que é aproximação:
                a moeda base é a que vale para cobrança. */}
            <span className="money-dual__secondary">{secondary}</span>
        </span>
    );
}

export default Money;
